var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 10.75C2.55109 10.75 2.20163 10.75 1.92597 10.6358C1.55843 10.4836 1.26642 10.1916 1.11418 9.82403C1 9.54837 1 9.19891 1 8.5V3.4C1 2.55992 1 2.13988 1.16349 1.81901C1.3073 1.53677 1.53677 1.3073 1.81901 1.16349C2.13988 1 2.55992 1 3.4 1H8.5C9.19891 1 9.54837 1 9.82403 1.11418C10.1916 1.26642 10.4836 1.55843 10.6358 1.92597C10.75 2.20163 10.75 2.55109 10.75 3.25M8.65 16H13.6C14.4401 16 14.8601 16 15.181 15.8365C15.4632 15.6927 15.6927 15.4632 15.8365 15.181C16 14.8601 16 14.4401 16 13.6V8.65C16 7.80992 16 7.38988 15.8365 7.06901C15.6927 6.78677 15.4632 6.5573 15.181 6.41349C14.8601 6.25 14.4401 6.25 13.6 6.25H8.65C7.80992 6.25 7.38988 6.25 7.06901 6.41349C6.78677 6.5573 6.5573 6.78677 6.41349 7.06901C6.25 7.38988 6.25 7.80992 6.25 8.65V13.6C6.25 14.4401 6.25 14.8601 6.41349 15.181C6.5573 15.4632 6.78677 15.6927 7.06901 15.8365C7.38988 16 7.80992 16 8.65 16Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.aaa1188ee3d8aa88a95c3d8a917c61d3.svg";
export { ForwardRef as ReactComponent };